import { render, staticRenderFns } from "./ProductsImpuestosFilter.vue?vue&type=template&id=accf0c00&scoped=true"
import script from "./ProductsImpuestosFilter.vue?vue&type=script&lang=js"
export * from "./ProductsImpuestosFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "accf0c00",
  null
  
)

export default component.exports